import type { ReactNode } from 'react';

import clsx from 'clsx';

import Typography from '~/shared/components/Typography';

/** Static metrics and titles — section carries full horizontal inset (px-5). */
const contentShellClass = 'border-b border-primary-70 bg-white px-5 py-6';

/** Clickable row lists — thin section shell (px-2); rows supply px-3 content inset. */
const interactiveShellClass = 'border-b border-primary-70 bg-white px-2 pb-3';

export type SidebarSectionVariant = 'content' | 'interactive';

interface SidebarCardProps {
  variant?: SidebarSectionVariant;
  title?: ReactNode;
  subtitle?: ReactNode;
  heading?: ReactNode;
  className?: string;
  children: ReactNode;
}

export default function SidebarCard({
  variant = 'content',
  title,
  subtitle,
  heading,
  className,
  children,
}: SidebarCardProps) {
  const isInteractive = variant === 'interactive';

  return (
    <div className={clsx(isInteractive ? interactiveShellClass : contentShellClass, className)}>
      {title != null && (
        <Typography
          variant="p2-semi"
          fontWeight={500}
          color="text-primary-900"
          className="mb-0.5 !leading-5"
        >
          {title}
        </Typography>
      )}
      {subtitle != null && (
        <Typography variant="caption" color="text-gray-700" className="mb-3.5">
          {subtitle}
        </Typography>
      )}
      {heading != null && (
        <Typography
          variant="p3-reg"
          fontWeight={500}
          color={isInteractive ? 'text-primary-900' : 'text-gray-700'}
          className={isInteractive ? 'px-3 pt-3 pb-3' : 'my-3'}
        >
          {heading}
        </Typography>
      )}
      {children}
    </div>
  );
}
